/**
 * SHARE LINK WINDOW
 * @author frédéric Pineau
 * par artwaï pour artwaï
 *
 * transform des liens html de partage pour qu'il s'ouvre dans une POPUP
 */
 (function () {
    
    var sharelinks = (window.collections) ? window.collections['sharelinks'] : document.querySelectorAll('.share-links a, .share-links .copy-link');
    
    sharelinks.forEach(function(link) {
        if(link.tagName == 'A') {
            link.addEventListener('click', function (e) {
                
                // Fixes dual-screen position                       
                const dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : window.screenX,
                    dualScreenTop = window.screenTop != undefined ? window.screenTop : window.screenY;
                
                const win=window,
                    d=document,
                    el=d.documentElement,
                    g=d.getElementsByTagName('body')[0],
                    width=win.innerWidth||el.clientWidth||g.clientWidth,
                    height=win.innerHeight||el.clientHeight||g.clientHeight;
                
                const w = 560,
                    h = 500,
                    left = ((width / 2) - (w / 2)) + dualScreenLeft,
                    top = ((height / 2) - (h / 2)) + dualScreenTop;
                
                const url = this.getAttribute("href"),
                    title = this.getAttribute("target"); 
                
                if(width>767) {  
                    e.preventDefault();
                    window.open(url, title, 'toolbar=yes,scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
                }
            
            });
        };
        if(link.className == 'copy-link') {
            link.addEventListener('click', function (e) {
                navigator.clipboard.writeText(window.location);
                link.classList.add("copy-linked");
            });
        }
    });

}());